<template>
  <el-dialog
    title="Promotion URL"
    class="promotion-url"
    :visible.sync="visible"
    width="60%"
    @close="$emit('update:show', false)"
  >
    <el-tabs v-model="active">
      <el-tab-pane v-for="link in links" :label="link.title" :key="link.title" :name="link.name">
        <p>{{ link.description }}</p>
        <div v-if="!link.dimension">
          <pre class="mt-4" v-highlightjs="link.content"><code class='html'></code></pre>
          <div class="center">
            <el-button class="mb-4" v-clipboard:copy="link.content" v-clipboard:success="onCopy">
              Copy
            </el-button>
          </div>
        </div>
        <div v-else>
          <el-row class="mt-2" type="flex" justify="space-between">
            <el-col :span="10">
              <div class="form-group">
                <label class="label">
                  {{ link.name === 'banner' ? 'Banner' : 'Iframe' }} dimension
                </label>
                <div class="form-control radio-group">
                  <el-select v-model="dimension">
                    <el-option
                      v-for="item in dimension_list"
                      :key="item.value"
                      :label="item.width + '*' + item.height"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="code-box" :style="{ height: dimension_list[dimension].height + 'px' }">
                <pre class="mt-4" v-highlightjs="link.content"><code class='html'></code></pre>
                <el-button v-clipboard:copy="link.content" v-clipboard:success="onCopy">
                  Copy Code
                </el-button>
              </div>
            </el-col>
            <el-col :span="10">
              <p class="p">preview</p>
              <div v-html="link.content"></div>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import '@lib/highlight/styles/atom-one-light.css'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      visible: this.show,
      active: 'default_url',
      dimension: 0,
      dimension_list: [],
    }
  },
  created() {
    let creative = {
      cpa: {
        adult: [
          {
            value: 0,
            width: '279',
            height: '248',
            url: 'cpa-a-279x248.jpg',
          },
          {
            value: 1,
            width: '300',
            height: '250',
            url: 'cpa-a-300x250.gif',
          },
        ],
        main: [
          {
            value: 0,
            width: '320',
            height: '480',
            url: 'cpa-m-320x480.jpeg',
          },
          {
            value: 1,
            width: '1349',
            height: '516',
            url: 'cpa-m-1349x516.png',
          },
          {
            value: 2,
            width: '1364',
            height: '604',
            url: 'cpa-m-1364x604.png',
          },
          {
            value: 3,
            width: '1365',
            height: '498',
            url: 'cpa-m-1365x498.png',
          },
        ],
      },
      cpi: [
        {
          value: 0,
          width: '400',
          height: '210',
          url: 'cpi-400x210.jpg',
        },
      ],
    }
    let ad_type = this.sml.ad_type === 1 ? 'cpi' : 'cpa'
    let restriction_type = this.sml.restriction_type === 1 ? 'main' : 'adult'

    this.dimension_list =
      this.sml.ad_type === 1 ? creative[ad_type] : creative[ad_type][restriction_type]
    if (this.sml.p_material.id) {
      this.$http
        .get(`/api/smartlink/creative/${this.sml.p_material.id}`, {
        })
        .then(data => {
          let creative = data.data
          creative.value = this.dimension_list.length // 用来区别的id
          this.dimension_list.push(creative)
        })
    }
  },
  computed: {
    ...mapGetters(['channel']),
    links() {
      let url = `https://${this.channel.domain}/aff_c?aid=${this.channel.id}&oid=${
        this.sml.gid
      }&source={pub_id}&aff_sub={click_id}&aff_sub2=`
      return [
        {
          title: 'DEFAULT URL',
          content: `${url}`,
          name: 'default_url',
          description:
            'Use this URL for your campaigns. Your traffic will be automatically sent to the best converting offer for each visitor',
        },
        /* eslint-disable no-useless-escape */
        {
          title: 'POP SCRIPT',
          content: `<script type="text/javascript" src="${
            window.location.origin
          }/static/jspu.js"><\/script><script>jspu('${url}')<\/script>`,
          name: 'pop_script',
          description:
            'Put  this HTML code between the <head> tags of your webside to automatically open your smart link in pop-under when a visitor clicks a link on your site.',
        },
        /* eslint-disable no-useless-escape */
        {
          title: 'BANNER SCRIPT',
          content: this.dimension_list[this.dimension].img_url ?  `<a href="${url}" target="_blank"><img src="${this.dimension_list[this.dimension].img_url}" width="${
            this.dimension_list[this.dimension].width
          }" height="${this.dimension_list[this.dimension].height}" border="0" /></a>` : `<a href="${url}" target="_blank"><img src="${window.location.origin +
            '/static/img/' +
            this.dimension_list[this.dimension].url}" width="${
            this.dimension_list[this.dimension].width
          }" height="${this.dimension_list[this.dimension].height}" border="0" /></a>`,
          dimension: true,
          name: 'banner',
          description:
            'Use this HTML code to place a smart banner on your website that will automatically display the banner with the highest CTR fot each visitor.',
        },
        {
          title: 'HTML LINK',
          content: `<a href='${url}'>Click here</a>`,
          name: 'html_link',
          description: 'Use this HTML code to place a smart link on your website',
        },
      ]
    },
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    sml: {
      type: Object,
      default: () => {
        return {
          oid: '',
        }
      },
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    onCopy() {
      this.notifyOpen()
    },
  },
  components: {},
}
</script>

<style lang="scss">
.promotion-url {
  .el-dialog__body {
    padding: 30px 40px;
  }

  .preview {
    background: #eaf2f6;
  }

  .p {
    line-height: 32px;
  }

  .form-group {
    justify-content: space-between;
  }
  .code-box {
    position: relative;
    .el-button {
      left: 50%;
      position: absolute;
      bottom: 0;
    }
  }
}
</style>
